﻿/**
* 应用配置
* 集中管理所有配置项，避免硬编码
*/

import type { SkillKey } from '../types'

// API 配置
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || '/api/v1'

// 图片域名配置
export const IMAGE_DOMAIN = import.meta.env.VITE_IMAGE_DOMAIN || 'https://aitool.ttcdw.cn'

// 技能 Token 配置键名
export const SKILL_TOKEN_KEYS: Record<SkillKey, string> = {
  activity: 'VITE_APP_TOKEN_ACTIVITY',
  system: 'VITE_APP_TOKEN_SYSTEM',
  learning: 'VITE_APP_TOKEN_LEARNING',
  growth: 'VITE_APP_TOKEN_GROWTH',
}

/**
* 获取技能对应的 Token
*/
export const getSkillToken = (skill: SkillKey): string => {
  const envKey = SKILL_TOKEN_KEYS[skill]
  return import.meta.env[envKey] || ''
}

// 技能列表
export const SKILL_KEYS: SkillKey[] = ['activity', 'system', 'learning', 'growth']

// 技能数据配置
export const SKILL_DATA: Record<SkillKey, string[]> = {
  activity: [
    '第十届启航杯线上展示时间安排？',
    '第十届启航杯现场展示活动时间安排？'
  ],
  system: [
    '启航杯系统登录方式？',
    '作品提交注意事项？',
    '公益讲座观看路径？'
  ],
  learning: [
    '能否推荐几个往届获得特等奖的优秀课例？',
    '如何从这些优秀课例中提炼出以学生为中心的亮点？',
    '高分课例视频在拍摄机位和后期剪辑上有什么技巧？'
  ],
  growth: []
}

// 欢迎语
export const WELCOME_TEXT = '我是新小师，是您教育生涯启航的智能伙伴！'

// 打字机配置
export const TYPEWRITER_CONFIG = {
  interval: 80,
  charsPerSecond: 20,
  tickInterval: 40,
  charsPerTick: 0.8,
}

// 状态文字列表
export const STATUS_KEYWORDS = ['正在分类中', '正在检索中', '正在查询中', '正在处理中', '正在分析中']

// 会话历史配置
export const HISTORY_CONFIG = {
  defaultLimit: 20,
}
